<div class="login-container">
  <div class="login-left">
    <div class="login-left_overlay">
      <div class="login-left_content">
        <div class="welcome-box">
          <span>{{ "WELCOME_TO_EDENT" | translate }}</span>
        </div>
        <h1 class="login-left_title">
          {{ "MANAGE" | translate }} <br />
          <span class="login-left_highlight">{{ "DENTAL" | translate }}</span>
          <br />
          {{ "CLINIC_EFFICIENTLY" | translate }}
        </h1>
        <p class="login-left_text">{{ "AUTOMATING_CLINIC" | translate }}</p>
      </div>
    </div>
  </div>
  <div class="login-right">
    <div class="login-content">
      <img
        [src]="'assets/layout/images/edent.uz-logo2.svg'"
        class="login-logo"
        alt="E-Dent"
      />
      <form [formGroup]="loginForm">
        <div class="input-group">
          <!-- <label for="userName">{{ "LOGIN" | translate }}</label> -->
          <label for="userName">{{ "FIRST_NAME" | translate }}</label>
          <input
            pInputText
            id="userName"
            formControlName="userName"
            placeholder="{{ 'USER_NAME' | translate }}"
            required
          />
        </div>
        <div class="input-group password-group">
          <label for="password">{{ "PASSWORD" | translate }}</label>
          <input
            [type]="showPassword ? 'text' : 'password'"
            pInputText
            id="password"
            formControlName="password"
            placeholder="{{ 'PASSWORD' | translate }}"
            required
          />
          <i
            class="pi"
            [ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
            (click)="togglePasswordVisibility()"
          ></i>
        </div>
        <div class="login-options">
          <p-checkbox
            label="{{ 'REMEMBER_ME' | translate }}"
            formControlName="rememberMe"
          ></p-checkbox>
          <a href="/forgot-password" class="forgot-password"
            >{{ "FORGOT_PASSWORD" | translate }}?</a
          >
        </div>
        <div *ngIf="errorMessage" class="error-message p-mb-3">
          {{ errorMessage }}
        </div>

        <div *ngIf="isLoading" class="spinner-container">
          <div class="spinner"></div>
        </div>
        <button
          pButton
          label="{{ 'LOGIN' | translate }}"
          type="submit"
          (click)="onLogin()"
          [disabled]="!loginForm.valid"
          class="login-btn"
        ></button>
      </form>
    </div>
  </div>
</div>
